import React, { Suspense } from 'react';
import { RouteObject } from 'react-router';
import PageSkeleton from '@/modules/ui/skeleton/PageSkeleton';

const HelpIndexPage = React.lazy(() => import('@/modules/help/pages/HelpIndexPage'));
const GettingStartedHelpPage = React.lazy(
  () => import('@/modules/help/pages/GettingStartedHelpPage'),
);
const QuotesHelpPage = React.lazy(() => import('@/modules/help/pages/QuotesHelpPage'));
const NoticesHelpPage = React.lazy(() => import('@/modules/help/pages/NoticesHelpPage'));
const IncidencesHelpPage = React.lazy(() => import('@/modules/help/pages/IncidencesHelpPage'));
const CalendarHelpPage = React.lazy(() => import('@/modules/help/pages/CalendarHelpPage'));
const ServicesHelpPage = React.lazy(() => import('@/modules/help/pages/ServicesHelpPage'));
const WorkOrdersHelpPage = React.lazy(() => import('@/modules/help/pages/WorkOrdersHelpPage'));
const CustomersHelpPage = React.lazy(() => import('@/modules/help/pages/CustomersHelpPage'));
const UsersHelpPage = React.lazy(() => import('@/modules/help/pages/UsersHelpPage'));
const AttendanceHelpPage = React.lazy(() => import('@/modules/help/pages/AttendanceHelpPage'));
const IncidenceUploadHelpPage = React.lazy(
  () => import('@/modules/help/pages/IncidenceUploadHelpPage'),
);
const ProductsHelpPage = React.lazy(() => import('@/modules/help/pages/ProductsHelpPage'));
const StockHelpPage = React.lazy(() => import('@/modules/help/pages/StockHelpPage'));
const ConsolidatedStockHelpPage = React.lazy(
  () => import('@/modules/help/pages/ConsolidatedStockHelpPage'),
);
const SerialNumbersHelpPage = React.lazy(
  () => import('@/modules/help/pages/SerialNumbersHelpPage'),
);
const SuppliersHelpPage = React.lazy(() => import('@/modules/help/pages/SuppliersHelpPage'));
const PurchaseInvoicesHelpPage = React.lazy(
  () => import('@/modules/help/pages/PurchaseInvoicesHelpPage'),
);
const InvoicesHelpPage = React.lazy(() => import('@/modules/help/pages/InvoicesHelpPage'));
const DeliveryNotesHelpPage = React.lazy(
  () => import('@/modules/help/pages/DeliveryNotesHelpPage'),
);
const AccountingHelpPage = React.lazy(() => import('@/modules/help/pages/AccountingHelpPage'));
const AccountsPayableHelpPage = React.lazy(
  () => import('@/modules/help/pages/AccountsPayableHelpPage'),
);
const BrandSettingsHelpPage = React.lazy(
  () => import('@/modules/help/pages/BrandSettingsHelpPage'),
);
const UserSettingsHelpPage = React.lazy(() => import('@/modules/help/pages/UserSettingsHelpPage'));
const CatalogsSettingsHelpPage = React.lazy(
  () => import('@/modules/help/pages/CatalogsSettingsHelpPage'),
);
const NotificationsSettingsHelpPage = React.lazy(
  () => import('@/modules/help/pages/NotificationsSettingsHelpPage'),
);

export const helpChildren: RouteObject[] = [
  {
    index: true,
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <HelpIndexPage />
      </Suspense>
    ),
  },
  {
    path: 'getting-started',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <GettingStartedHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'quotes',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <QuotesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'notices',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <NoticesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'incidences',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <IncidencesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'calendar',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <CalendarHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'services',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <ServicesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'work-orders',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <WorkOrdersHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'customers',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <CustomersHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'users',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <UsersHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'attendance',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <AttendanceHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'incidence-upload',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <IncidenceUploadHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'products',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <ProductsHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'stock',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <StockHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'consolidated-stock',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <ConsolidatedStockHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'serial-numbers',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <SerialNumbersHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'suppliers',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <SuppliersHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'purchase-invoices',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <PurchaseInvoicesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'invoices',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <InvoicesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'delivery-notes',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <DeliveryNotesHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'accounting',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <AccountingHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'accounts-payable',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <AccountsPayableHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'brand',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <BrandSettingsHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'user',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <UserSettingsHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'catalogs',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <CatalogsSettingsHelpPage />
      </Suspense>
    ),
  },
  {
    path: 'notifications',
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <NotificationsSettingsHelpPage />
      </Suspense>
    ),
  },
];
